/**
 * Created by 20110925 on 29/05/2017.
 */
/**
 * Configure notification widget
 */

class HelperUI {
    static init() {
        $ = App.common.jQuery
        HelperUI.configure_notification_dialog();
        HelperUI.configure_notification_widget();
    }

    static configure_notification_widget(){
        $("#popupNotification").kendoNotification({
            position: {  pinned: true },
            autoHideAfter: 0,
            stacking: "up",
            animation: {
                open: {
                    effects: "slideIn:left"
                },
                close: {
                    effects: "slideIn:left",
                    reverse: true
                }
            },
            templates: [{
                type: "warning",
                template: $("#warningTemplate").html()
            }, {
                type: "error",
                template: $("#errorTemplate").html()
            }, {
                type: "good",
                template: $("#successTemplate").html()
            }]
        });
    }

    /**
     * Convenient function to display notifications
     * @param type type of the message
     * @param msg notification message
     * @param title title of the message
     */
    static show_notification(type = "warning", msg = "No message", title, hideCallback){
        var popupNotification = $("#popupNotification").data("kendoNotification");
        var defaultTitle = "";

        if(type == "error") defaultTitle = "Error Message";
        else if(type == "warning") defaultTitle = "Warning Message";
        else if(type == "success") defaultTitle = "Success Message";
        else defaultTitle = "Message";

        popupNotification.show({
            title: title ? title : defaultTitle,
            message: msg
        }, type);

        if(hideCallback) {
            popupNotification.bind("hide", hideCallback);
        } else {
            popupNotification.unbind("hide");
        }

    }

    /**
     * Function that configures notification dialog
     */
    static configure_notification_dialog(){
        $("#dialog").kendoDialog({
            content: "<em>Dialog content</em>",
            visible : false,
            width: 400
        });
    }
    /**
     * A dialog that shows success or error messages
     * @param title
     * @param message
     * @param callbackFunc
     */
    static show_dialog(title = "Notification", message, callbackFunc){
        var dialog = $("#dialog").data("kendoDialog");
        dialog.title(title)
        dialog.content(message);
        if(callbackFunc) dialog.bind("close", callbackFunc);
        dialog.open();
    }

}
module.exports = HelperUI
